import { action, makeAutoObservable } from "mobx";
import { observer } from "mobx-react";
import { h, render } from "preact";
import { debugAvailabilityErrors, localizePath, Tracking, } from "restaumatic-client";
import { scrollToError } from "../../utils/Scroll";
import * as Modals from "../../utils/Modals";
import Cart from "./Cart";
export const CART_MODAL_ID = "cart";
export function init(state) {
    const modalElement = state.initializeDomElement();
    render(h(CartModal, { state: state }), modalElement);
}
export class CartState {
    constructor(cart) {
        this.cart = cart;
        this._isRedirecting = false;
        makeAutoObservable(this);
    }
    get isRedirecting() {
        return this._isRedirecting;
    }
    initializeDomElement() {
        // Create and append the modal element
        const modalElement = document.createElement("div");
        modalElement.id = CART_MODAL_ID;
        modalElement.classList.add("modal", "fade", "cart", "cart--modal", "cart--redesigned");
        modalElement.tabIndex = -1;
        modalElement.addEventListener("shown.bs.modal", action(() => {
            this.cart.setCartOpen();
            this._isRedirecting = false;
        }));
        modalElement.addEventListener("hidden.bs.modal", action(() => {
            this.cart.setCartClosed();
        }));
        document.body.appendChild(modalElement);
        return modalElement;
    }
    showModal(element) {
        void Modals.showModal(CART_MODAL_ID, element);
    }
    hideModal() {
        void Modals.hideModal(CART_MODAL_ID);
    }
    goToCheckout(isSubmitDisabled) {
        if (isSubmitDisabled) {
            scrollToError("#cart", [".alert-danger", ".alert-warning", ".has-error"]);
            Tracking.trackEvent({
                tag: "CartAvailabilityError",
                contents: {
                    ...this.cart.checkoutLoggingData,
                    restaurantId: this.cart.restaurantId.value,
                    totalPrice: this.cart.priceValue,
                    errors: debugAvailabilityErrors(this.cart.availability),
                },
            });
            return;
        }
        location.href = localizePath(`/zamowienie/koszyk/${this.cart.restaurantId.toString()}`);
        // NOTICE: In the Active Menu we are always on the same page, so we need to hide the modal
        if (Skubacz.Device.isInIframe()) {
            this.hideModal();
        }
        else {
            // Temp. hack to show loading state on the "Go to checkout" button while redirecting
            // We need a better solution for this, e.g. redirecting to the checkout page without reloading the page (SPA-like routing?)
            this._isRedirecting = true;
            // Clean up if user navigates to a new page / performed "back" action
            window.addEventListener("pageshow", action(() => {
                this._isRedirecting = false;
            }), { once: true });
            // Safety timeout remains as backup for eg. network issues
            setTimeout(action(() => {
                this._isRedirecting = false;
            }), 6000);
        }
    }
}
const CartModal = observer(({ state }) => {
    var _a;
    const urn = (_a = Skubacz.configuration.theme_settings.cart_modal_image) !== null && _a !== void 0 ? _a : null;
    const imageUrn = urn !== null && urn.trim().length !== 0 ? urn.trim() : null;
    return (h("div", { class: `modal-dialog ${imageUrn === null ? "" : "modal-dialog--with-image"}` },
        h("div", { class: "modal-content" },
            h(Cart, { state: state, imageUrn: imageUrn }))));
});
